import LoginService from '@/service/LoginService';
const loginService = new LoginService();

export default{
    namespaced: true,
    state() {
        return {
            email: "",
            tokens : {
                access: null,
                expires_in: null,
                refresh_token: null,
                id_token: null
            },
        }
    },
    getters: {
        getEmail: state => {
            return state.email
        },
        getAccessToken: state => {
            return state.tokens.access;
        },
        getRefreshToken: state => {
            return state.tokens.refresh_token;
        }
    },
    mutations: {
        logout: function(state) {
            console.log("LOGOUT");
            state.tokens.access = state.tokens.expires_in = state.tokens.id_token = state.tokens.refresh_token = null;
        },
        loginData: function (state, payload) {
            state.tokens.access = payload.access_token;
            state.tokens.expires_in = payload.expires_in;
            state.tokens.refresh_token = payload.refresh_token;
            state.tokens.id_token = payload.id_token;
            state.email = payload.email;
            sessionStorage.setItem("sessionActive",true);
        },
        refreshToken: function (state, payload) {
            state.tokens.access = payload.access_token;
            state.tokens.refresh_token = payload.refresh_token;
        },
        initUserdata: function(state) {
            if (state.email) {
                if(!sessionStorage.getItem("sessionActive")) {
                    state.tokens.access = state.tokens.expires_in = state.tokens.id_token = state.tokens.refresh_token = null;
                }
            } else {
                state.tokens.access = state.tokens.expires_in = state.tokens.id_token = state.tokens.refresh_token = null;
            }
        },
    },
    actions: {
        init({ commit, dispatch }) {
            commit('initUserdata');
            setInterval(function() {
                dispatch("refreshToken");
            },(50*60*1000)); //expire token 1h, set refresh token every 50 min
        },
        refreshToken: async ({ commit, state }) => {
            let refreshToken = state.tokens.refresh_token;
            if(refreshToken) {
                await loginService.refresh(refreshToken).then((data) => {
                    console.log("Personal Token refreshed");
                    commit('refreshToken', { 
                    access_token: data.access_token,
                    refresh_token: data.refresh_token
                    });
                }).catch(error => {
                    if( error.response ){
                    console.log(error.response.data); // => the response payload 
                    } else {
                    console.log(JSON.stringify(error));
                    }
                    commit('logout');
                });
                } else {
                commit('logout');
            }   
        },
    }
};


